
import { ITagAssociationType } from "../../common/models/ITagAssociationType";
import restService from "../rest-service/RestService";
import { IDeviceSubType, IDeviceType, IReferenceTimeZoneDTO } from "./Models";

type TatsQueryParams = {
    inUse: boolean;
};

const GlobalDataService = {

    getTimeZones: async function (abortSignal?: AbortSignal): Promise<IReferenceTimeZoneDTO[]> {
        const response = await restService.get<IReferenceTimeZoneDTO[]>(`/timezones`, abortSignal);
        return response.data;
    },
    getTats: async function (inUse: boolean, abortSignal?: AbortSignal): Promise<ITagAssociationType[]> {

        const queryParam: TatsQueryParams = {
            inUse: inUse
        };

        const response = await restService.get<ITagAssociationType[], TatsQueryParams>(`/tats`, abortSignal, queryParam);
        return response.data;
    },
    getDeviceTypes: async function (abortSignal?: AbortSignal): Promise<IDeviceType[]> {
        const response = await restService.get<{
            id: number,
            n: string,
            d: string,
            im: string,
            if: boolean;
        }[]>(`/device-types`, abortSignal);
        return response.data.map(o => {
            return {
                id: o.id,
                name: o.n,
                description: o.d,
                image: o.im,
                includeInFacilities: o.if
            };
        });
    },
    getDeviceSubTypes: async function (abortSignal?: AbortSignal): Promise<IDeviceSubType[]> {
        const response = await restService.get<{
            id: number,
            n: string,
            pt: number;
        }[]>(`/device-subtypes`, abortSignal);
        return response.data.map(o => {
            return {
                id: o.id,
                name: o.n,
                parentTypeID: o.pt
            };
        });
    }
};

export default GlobalDataService;

const defaultTimezoneValue: IReferenceTimeZoneDTO = {
    id: 20,
    name: '(GMT-06:00) Central Time (US & Canada)',
    standardName: '(GMT-06:00) Central Time (US & Canada)',
    olsonTimezone: 'America/Chicago'
};
export { defaultTimezoneValue };